export enum EAgentPortfolioQueryKey {
  AGENT_PORTFOLIO = 'agent-portfolio',
  AGENT_PORTFOLIO_TIME_SERIES = 'agent-portfolio-time-series',
  AGENT_PERFORMANCE = 'agent-performance',
  AGENT_PERFORMANCE_CHART = 'agent-performance-chart',
  AGENT_OTC_GET_HISTORY = 'agent-otc-get-history',
  AGENT_WALLET_PORTFOLIO_CHART = 'agent-wallet-portfolio-chart',
}
